<app-page-bar></app-page-bar>

<app-page>

  <h2>Invoice</h2>

  <div class="invoice-create-grid">
    <div>

      <mat-card>

        <app-card-title title="Information"></app-card-title>

        <form [formGroup]="form" id="invoice-create-form" (ngSubmit)="save()" *ngIf="countries$ | async as countries"
              novalidate>

          <div class="card-section-container">

            <div class="card-section">

              <h4>Client</h4>

              <mat-form-field>
                <input matInput
                       placeholder="Client Search"
                       aria-label="Client"
                       [matAutocomplete]="auto"
                       [formControl]="clientCtrl">
              </mat-form-field>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="clientSelected($event.option.value)">
                <mat-option *ngFor="let client of clients$ | async" [value]="client">
                  {{client.name}}
                </mat-option>
              </mat-autocomplete>

              <mat-form-field>
                <input matInput placeholder="Name" formControlName="name" />
              </mat-form-field>

              <mat-form-field>
                <mat-select placeholder="Country" formControlName="country">
                  <mat-option *ngFor="let option of countries.all()" [value]="option.code">
                    {{option.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <input matInput placeholder="Business Id" formControlName="business_id" />
              </mat-form-field>

              <mat-form-field>
                <input matInput placeholder="Bank Account (IBAN)" formControlName="iban" [matAutocomplete]="bankAccountAuto"/>
              </mat-form-field>
              <mat-autocomplete #bankAccountAuto="matAutocomplete" panelWidth="auto">
                <ng-container *ngIf="bankAccounts$ | async as bankAccounts">
                  <mat-option *ngFor="let account of bankAccounts" [value]="account.iban"
                              [class.bank-account-verified]="!!account.verified_at">
                    <mat-icon *ngIf="account.verified_at" class="verified-icon">check_circle</mat-icon>
                    {{ account.iban | ibanFormatter }}
                    <span class="not-verified-hint" *ngIf="!account.verified_at">ownership not confirmed</span>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>

            <div class="card-section">

              <h4>Representative</h4>

              <mat-form-field>
                <mat-select (selectionChange)="clientRepresentativeSelected($event)" formControlName="clientRepresentative">
                  <mat-option>New</mat-option>
                  <mat-option *ngFor="let clientRepresentative of clientRepresentatives$ | async"
                              [value]="clientRepresentative">{{clientRepresentative.first_name}}
                    {{clientRepresentative.last_name}} ({{clientRepresentative.id}})</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <input matInput placeholder="Social Security Number" formControlName="socialSecurityNumber" />
              </mat-form-field>

              <mat-form-field>
                <input matInput placeholder="First Name" formControlName="firstName" />
              </mat-form-field>

              <mat-form-field>
                <input matInput placeholder="Last Name" formControlName="lastName" />
              </mat-form-field>

              <mat-form-field>
                <input matInput placeholder="Email" formControlName="email" />
              </mat-form-field>

              <mat-form-field>
                <input matInput placeholder="Phone" formControlName="phone" />
              </mat-form-field>
            </div>

          </div>

          <div class="card-section-container">

            <div class="card-section">
              <div class="drop-zone" appFileUpload (fileAdded)="uploadFileAdded($event)">
                <p>Drag and drop files here</p>
                <mat-icon>cloud_upload</mat-icon>
              </div>
            </div>

            <div class="card-section" *ngIf="uploadFiles.length > 0">
              <mat-list>
                <mat-list-item *ngFor="let f of uploadFiles">
                  <mat-icon matListIcon>attachment</mat-icon>
                  <span matLine>{{f.name}}</span>
                  <button type="button" mat-icon-button (click)="removeUploadFile(f)" style="margin-left: 16px">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-list-item>
              </mat-list>
            </div>

          </div>

        </form>

        <mat-card-actions align="end">
          <button type="submit" mat-button [disabled]="!form.valid" form="invoice-create-form">Save</button>
        </mat-card-actions>

      </mat-card>

    </div>
    <div>
    </div>
  </div>

</app-page>
